import DOMPurify from 'dompurify';

interface RichTextDisplayProps {
  content: string;
  className?: string;
}

const ALLOWED_TAGS = [
  'p', 'br', 'strong', 'b', 'em', 'i', 'u', 's', 'del',
  'h3', 'ul', 'ol', 'li', 'a', 'blockquote', 'code', 'pre',
];
const ALLOWED_ATTR = ['href', 'target', 'rel'];

function isHtml(text: string): boolean {
  return /<[a-z][\s\S]*>/i.test(text);
}

export default function RichTextDisplay({ content, className = '' }: RichTextDisplayProps) {
  if (!content) return null;

  // Plain text fallback — identical to previous behavior
  if (!isHtml(content)) {
    return (
      <p className={`text-sm text-text-secondary whitespace-pre-wrap leading-relaxed ${className}`}>
        {content}
      </p>
    );
  }

  const clean = DOMPurify.sanitize(content, {
    ALLOWED_TAGS,
    ALLOWED_ATTR,
  });

  return (
    <div
      className={`prose prose-sm dark:prose-invert max-w-none ${className}`}
      dangerouslySetInnerHTML={{ __html: clean }}
    />
  );
}
